import { FC } from 'react'
import styled from 'styled-components'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { EmbroideryService } from '../../../../../containers/EmbroideryService'
import { EmbroideryPlacementDetails } from '../../../../../types/graphql'
import { PlacementSelector } from '../../selectors/PlacementSelector'
import { EmbroideryOptionWrapper as SharedEmbroideryOptionWrapper } from '../../shared-form-styles'
import { LogoFormContainer } from '../LogoFormContainer'
import { normalizeDigitizationSettingToEmbroideryKind } from '../utils'

export const LogoPlacement: FC = () => {
  const { choosePlacement, embroideryOptions, selectedFormKind } = EmbroideryService.useContainer()
  const { addLogoForm } = LogoFormContainer.useContainer()

  // these should be derived from the selected logo
  const kind = normalizeDigitizationSettingToEmbroideryKind(
    addLogoForm.values?.logoFile?.digitizationSetting
  )

  const {
    embroidery: {
      modal: {
        forms: { dtcLogoEmbroideryForm: fixtures },
      },
    },
  } = useTranslation()

  const placements: EmbroideryPlacementDetails[] | undefined = embroideryOptions
    ?.find(option => option.kind === kind)
    ?.logoPlacements?.map(placement => ({
      ...placement,
      name: placement.offsetKey === 'left-chest' ? fixtures.leftChest : fixtures.rightChest,
      heapCtaName: placement.offsetKey === 'left-chest' ? 'Left Chest' : 'Right Chest',
      flatlayKind: 'flatlay-chest',
    }))

  if (!placements) return null

  const handleSelectLogoPlacement = (logoPlacement: EmbroideryPlacementDetails) => {
    choosePlacement(selectedFormKind, logoPlacement)
    addLogoForm.setFieldValue('logoPlacement', logoPlacement)
  }

  return (
    <EmbroideryOptionWrapper>
      <PlacementSelector
        errorMessage={
          addLogoForm.touched.logoPlacement ? addLogoForm.errors.logoPlacement : undefined
        }
        label={fixtures.logoPlacement}
        labelId={`${fixtures.logoPlacement}-id`}
        onSelectPlacement={handleSelectLogoPlacement}
        placementOptions={placements}
        selectedPlacementOption={addLogoForm.values.logoPlacement}
      />
    </EmbroideryOptionWrapper>
  )
}

const EmbroideryOptionWrapper = styled(SharedEmbroideryOptionWrapper)`
  margin: ${({ theme }) => theme.spacing(6, 0, 6, 0)};
`
